<template>
  <Modal
    :value="value"
    title="试卷预览"
    width="760"
    :footer-hide="true"
    @input="OnInput"
    @on-visible-change="OnVisibleChange"
  >
    <div class="preview-body">
      <Spin size="large" fix v-if="loading"/>
      <template v-if="!loading">
        <div class="meta">
          <span class="label">试卷名称：</span>{{ meta.evaluation_name || '-' }}
          <span class="label" style="margin-left:24px;">总时长：</span>{{ FormatSecond(meta.evaluation_total_time) }}
          <span class="label" style="margin-left:24px;">总分：</span>{{ meta.evaluation_total_score || '-' }}
        </div>

        <div
          v-for="(block, bi) in groups"
          :key="bi"
          class="block"
        >
          <div class="block-title">
            {{ block.title || ('题型 ' + block.type_id) }}
            <span class="num">共 {{ (block.question || []).length }} 题</span>
          </div>
          <div class="block-desc" v-if="block.desc">{{ block.desc }}</div>

          <div
            v-for="(q, qi) in (block.question || [])"
            :key="qi"
            class="qrow"
          >
            <span class="qidx">{{ qi + 1 }}.</span>
            <div class="qmain">
              <div v-if="q.word">
                <b>{{ q.word }}</b>
                <span v-if="q.meaning" class="meaning"> （{{ q.meaning }}）</span>
              </div>
              <div class="qpic" v-if="q.pic">
                <img :src="q.pic" />
              </div>
              <div v-if="q.sentence">{{ q.sentence }}</div>
              <div v-if="q.question">{{ q.question }}</div>
              <div v-if="q.answer" class="qanswer">参考答案：{{ q.answer }}</div>
              <div v-if="q.dialogue && q.dialogue.length" class="qdialogue">
                <div
                  v-for="(d, di) in q.dialogue"
                  :key="di"
                  class="drow"
                  :class="{ 'd-bot': d.is_bot == 1, 'd-user': d.is_bot == 0 }"
                >
                  <span class="d-role">{{ d.is_bot == 1 ? '机器' : '我' }}</span>
                  <span class="d-text">{{ d.sentence }}</span>
                </div>
              </div>
              <div class="qmeta">
                <span>分值：{{ q.score }}</span>
                <span v-if="q.second" style="margin-left:12px;">时长：{{ q.second }}s</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!groups.length" class="empty">暂无题目数据</div>
      </template>
    </div>
  </Modal>
</template>

<script>
import evaluationApi from '@/lib/api/evaluation'

export default {
  name: 'EvaluationPreview',
  props: {
    value: { type: Boolean, default: false },
    hopeEvaluationId: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      meta: {},
      groups: []
    }
  },
  methods: {
    OnInput(v) {
      this.$emit('input', v)
    },
    OnVisibleChange(visible) {
      if (visible && this.hopeEvaluationId) {
        this.Load()
      }
    },
    Load() {
      this.loading = true
      this.groups = []
      this.meta = {}
      evaluationApi.GetPreviewEvaluationData({
        hopeEvaluationId: this.hopeEvaluationId
      }).then(res => {
        this.loading = false
        if (res.status == 1) {
          const data = res.data || {}
          this.meta = {
            evaluation_name: data.evaluation_name,
            evaluation_total_time: data.evaluation_total_time,
            evaluation_total_score: data.evaluation_total_score
          }
          this.groups = data.question_type || []
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    FormatSecond(sec) {
      if (!sec) return '-'
      const s = Number(sec) || 0
      const m = Math.floor(s / 60)
      const r = s % 60
      return `${m}分${r}秒`
    }
  }
}
</script>

<style lang="less" scoped>
.preview-body {
  min-height: 200px;
  max-height: 70vh;
  overflow-y: auto;
  position: relative;
  .meta {
    font-size: 14px;
    color: #333;
    margin-bottom: 12px;
    .label { color: #999; }
  }
  .block {
    margin-bottom: 16px;
    padding: 12px;
    background: #fafafa;
    border-radius: 6px;
    .block-title {
      font-weight: 600;
      font-size: 15px;
      margin-bottom: 6px;
      .num {
        font-weight: normal;
        font-size: 12px;
        color: #999;
        margin-left: 8px;
      }
    }
    .block-desc {
      font-size: 12px;
      color: #888;
      line-height: 1.5;
      margin-bottom: 8px;
    }
    .qrow {
      display: flex;
      align-items: flex-start;
      padding: 8px 0;
      border-bottom: 1px dashed #eee;
      &:last-child { border-bottom: none; }
      .qidx { width: 24px; color: #999; flex-shrink: 0; }
      .qmain {
        flex: 1;
        word-break: break-all;
        font-size: 14px;
        line-height: 1.6;
        b { color: #1890ff; font-size: 16px; }
        .meaning { color: #999; font-size: 13px; }
        .qpic img {
          max-width: 200px;
          max-height: 140px;
          border-radius: 4px;
          margin: 4px 0;
        }
        .qanswer {
          font-size: 13px;
          color: #52c41a;
          padding: 4px 8px;
          background: #f6ffed;
          border-radius: 4px;
          display: inline-block;
          margin-top: 4px;
        }
        .qdialogue {
          margin-top: 4px;
          .drow {
            display: flex;
            align-items: flex-start;
            padding: 4px 0;
            .d-role {
              width: 32px;
              font-size: 11px;
              color: #999;
              flex-shrink: 0;
              padding-top: 4px;
            }
            .d-text {
              flex: 1;
              padding: 4px 10px;
              border-radius: 10px;
              font-size: 13px;
            }
            &.d-bot .d-text { background: #f0f0f0; color: #333; }
            &.d-user .d-text { background: #e6f7ff; color: #1890ff; }
          }
        }
        .qmeta {
          font-size: 12px;
          color: #ff7a45;
          margin-top: 4px;
        }
      }
    }
  }
  .empty {
    text-align: center;
    color: #999;
    padding: 40px 0;
  }
}
</style>
